import React, {Component} from 'react'
import {
    Card,
    Tooltip,
    Table,
    Button,
    message,
    notification,
    Badge,
    Tag,
    Form,
    Input, Popover, Pagination, Select,DatePicker, Divider, InputNumber
} from 'antd';
import {getLogList, getLogSummary, getUserListForDropbox} from '../../../request'
import * as Icon from '@ant-design/icons';
import moment from "moment";
import ReactJson from 'react-json-view'
import './index.less'
let columnsKey = {
    index: '序号',
    logtime: 'logTime',
    访问时间: "访问时间",
    耗时: "耗时(ms)",
    环境: "环境",
    系统: "系统",
    页面: "页面",
    接口: "接口",
    访问方式: "访问方式",
    参数: "参数",
    网关: "网关/端口",
    目标机器: "目标机器/端口",
    访问状态: "访问状态",
    员工姓名: "员工姓名",
    IP: "客户端IP",
    userTicket: "userTicket",
    唯一ID: "唯一ID",
}

const summaryDimensionOptions = [
    {label:'接口', value:'interface'},
    {label:'系统', value:'system'},
    {label:'员工姓名', value:'user'},
    {label:'员工ID', value:'userId'},
    {label:'userTicket', value:'userTicket'},
    {label:'请求状态', value:'status'},
    {label:'请求方式', value:'method'},
    {label:'客户端IP', value:'ip'},
    {label:'页面', value:'page'},
]

const summaryTimeUnitOptions = [
    {label:'不分时间', value:''},
    {label:'按分钟', value:'minute'},
    {label:'按小时', value:'hour'},
    {label:'按天', value:'day'},
    {label:'按周', value:'week'},
    {label:'按月', value:'month'},
]

export default class Log extends Component {
    formRef = React.createRef();
    state = {
        dataSource:[],
        userList:[],
        columns:[],
        summaryColumns:[],
        summaryDataSource:[],
        loading:false,
        summaryLoading:false,
        visible:false,
        systemItem:{},
        summaryParam:{
            dimension:'interface',
            timeUnit:'',
            limit:100,
        },
        formParam:{
            pageSize:20,
            currentPage:1
        }
    };
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'center'
            }
            if(item=='index'){
                return {
                    ...initObj,
                    width:60,
                    fixed: 'left',
                    render:(text,record,index)=>{
                        return index+1
                    }
                }
            }else if(item=='参数'){
                return {
                    ...initObj,
                    width: 200,
                    render:(text,record)=>{
                        let content = ''
                        try {
                            let textE = text?JSON.parse(text||'{}'):''
                            content = <ReactJson src={textE}/>
                        }catch (e) {
                            const reg = /(\w+)=(\[)([^\]]*)(\])/g;
                            if(reg.test(text)){

                                let textSet = text.replace(reg,'"$1":"$3"')
                                try{
                                    textSet = JSON.parse(textSet)
                                    content = <ReactJson src={textSet}/>
                                }catch (e) {
                                    content = text
                                }
                            }else{
                                content = text
                            }
                        }
                        return <Popover placement={'left'} content={
                            <div style={{width:'400px',height:'400px',overflowY:'scroll'}}>
                                {content}
                            </div>
                        } title="参数明细">
                            <Button size={'small'} type="danger">查看参数</Button>
                        </Popover>

                    }
                }
            }else if(item=='员工姓名'){
                return {
                    ...initObj,
                    width: 100
                }

            }else if(item=='访问时间'){
                return {
                    ...initObj,
                    width: 180
                }

            }else if(item=='目标机器'){
                return {
                    ...initObj,
                    width: 200,
                    align: 'left',
                    render:(text,record)=>{
                        return(
                            text?
                            <>
                                <Badge status={'processing'} text={'机器：'+text}></Badge><br/>
                                <Badge status={'processing'} text={'端口：'+record['目标端口']}></Badge>
                            </>:''
                        )
                    }
                }

            }else if(item=='网关'){
                return {
                    ...initObj,
                    align: 'left',
                    width: 200,
                    render:(text,record)=>{
                        return(
                            text?
                            <>
                                <Badge status={'success'} text={'机器：'+text}></Badge><br/>
                                <Badge status={'success'} text={'端口：'+record['网关端口']}></Badge>
                            </>:''
                        )
                    }
                }

            }else if(item=='logtime'){
                return {
                    ...initObj,
                    width:180,
                    fixed: 'left',
                    render:(text, record, index)=> {
                        return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }
    initTableDataList(){
        this.setState({ loading: true });
        getLogList(this.state.formParam).
        then(res=>{
            this.setState({
                loading: false,
                dataSource:res.list,
                total:res.total
            })
        })
    }
    initSummaryDataList(){
        this.setState({ summaryLoading: true });
        getLogSummary({
            ...this.state.formParam,
            ...this.state.summaryParam,
        }).then(res=>{
            this.setState({
                summaryLoading: false,
                summaryDataSource:res.list||[],
                summaryColumns:this.createSummaryColumns(this.state.summaryParam),
            })
        }).catch(()=>{
            this.setState({
                summaryLoading: false
            })
        })
    }
    createSummaryColumns = (summaryParam)=>{
        let columns = []
        if(summaryParam.timeUnit){
            columns.push({
                title:'时间',
                dataIndex:'time',
                key:'time',
                width:180,
                align:'center',
            })
        }
        columns.push({
            title:(summaryDimensionOptions.find(item=>item.value==summaryParam.dimension)||{}).label||'维度',
            dataIndex:'dimensionValue',
            key:'dimensionValue',
            align:'center',
        })
        columns.push({
            title:'PV',
            dataIndex:'pv',
            key:'pv',
            width:120,
            align:'center',
            sorter:(a,b)=>(Number(a.pv)||0)-(Number(b.pv)||0),
            defaultSortOrder:'descend',
        })
        columns.push({
            title:'平均耗时(ms)',
            dataIndex:'avgCost',
            key:'avgCost',
            width:160,
            align:'center',
            render:(text)=>text||text===0?Number(text).toFixed(2):''
        })
        columns.push({
            title:'最大耗时(ms)',
            dataIndex:'maxCost',
            key:'maxCost',
            width:160,
            align:'center',
        })
        return columns
    }
    initUserList = ()=>{
        getUserListForDropbox({type:0}).
        then(res=>{
            this.setState({
                userList:[...res]
            })
        })
    }
    handleValueChange = (values,allValues)=>{
        console.log('change',values,allValues)
        let param = {...this.state.formParam}
        let selKeys = Object.keys(values)
        let selValues = Object.values(values)
        console.log('rrr',values,selKeys,selValues,param)
        if(selKeys[0]=='requestTime'){
            param.requestTime = selValues[0]?moment(selValues[0]).format('YYYY-MM-DD HH:mm:ss'):null
        }else if(selKeys[0]=='requestRangeTime'){
            param.start = selValues[0]?moment(selValues[0][0]).format('YYYY-MM-DD HH:mm:ss'):null
            param.end = selValues[0]?moment(selValues[0][1]).format('YYYY-MM-DD HH:mm:ss'):null
        }else{
            param[selKeys[0]] = selValues[0]?selValues[0]:null
        }
        console.log(param)
        this.setState({
            formParam:param
        })

    }
    handleSubmit = (values,allValues)=> {
        console.log(values, allValues)
        let {requestRangeTime, ...otherParam} = {...this.state.formParam}
        console.log(otherParam)
        otherParam.currentPage = 1
        this.setState({
            formParam:otherParam
        })
        this.initTableDataList()
    }
    handleReset = ()=>{
        console.log()
        this.formRef.current.resetFields()
        this.setState({
            formParam:{
                currentPage:1,
                pageSize:10,
            }
        },()=>{
            this.initTableDataList()
            this.initSummaryDataList()
        })

    }
    handleCloseModel = ()=>{
        this.setState({
            visible:false,
        })
    }
    copyTestCode = (text)=>{
        console.log(text)
        var input = document.createElement("textarea"); // 创建input对象
        input.value = text; // 设置复制内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        message.success('已复制到剪贴板');
    }
    componentDidMount(){
        this.createColumns(columnsKey);
        this.initTableDataList()
        this.initSummaryDataList()
        this.initUserList()
    }
    render() {
        const { dataSource,columns, loading,visible,systemItem} = this.state;
        return (
            <div className='log-wrap'>
                <Card title="日志" bordered={false}>
                    <Form layout="inline" ref={this.formRef}
                          onFinish={this.handleSubmit}
                          onValuesChange={this.handleValueChange}>
                        <Form.Item name="interfaceName">
                            <Input placeholder="接口名称" />
                        </Form.Item>
                        <Form.Item name="sysName">
                            <Input placeholder="系统名称" />
                        </Form.Item>
                        <Form.Item name="times">
                            <Input placeholder="耗时" />
                        </Form.Item>
                        <Form.Item name="pagePath">
                            <Input placeholder="页面路径" />
                        </Form.Item>
                        <Form.Item name="userTicket">
                            <Input placeholder="userTicket" />
                        </Form.Item>
                        <Form.Item name="environment">
                            <Input placeholder="环境" />
                        </Form.Item>
                        <Form.Item name="ip">
                            <Input placeholder="ip" />
                        </Form.Item>
                        <Form.Item name="targetMachine">
                            <Input placeholder="目标机器" />
                        </Form.Item>
                        <Form.Item name="port">
                            <Input placeholder="端口号" />
                        </Form.Item>
                        <Form.Item name="gateway">
                            <Input placeholder="网关" />
                        </Form.Item>
                        <Form.Item name="gatewayPort">
                            <Input placeholder="网关端口号" />
                        </Form.Item>
                        <Form.Item name="requestStatus">
                            <Input placeholder="请求状态" />
                        </Form.Item>

                        <Form.Item name="action">
                            <Select
                                style={{width:'180px'}}
                                allowClear
                                showSearch
                                placeholder="请求方式"
                                filterOption={(input, option) =>
                                    (option?.name ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={[
                                    {label:'post',value:'post'},
                                    {label:'get',value:'get'},
                                    {label:'put',value:'put'},
                                    {label:'delete',value:'delete'},
                                ]}
                            />
                        </Form.Item>
                        <Form.Item name={'userId'}>
                            <Select
                                style={{width: '180px'}}
                                showSearch
                                optionFilterProp="children"
                                fieldNames={{
                                    label: 'USER_NICK',
                                    value: 'USER_ID'
                                }}
                                filterOption={(input, option) => {
                                    let searchText = (option?.USER_NICK ?? '') + (option?.pinyin ?? '')
                                    return searchText.toLowerCase().includes(input.toLowerCase())
                                }
                                }
                                allowClear
                                placeholder="请选择员工姓名"
                                options={this.state.userList}
                                onChange={this.handleUserChange}
                            />
                        </Form.Item>
                        <Form.Item name="requestTime">
                            <DatePicker showTime valueFormat={'YYYY-MM-DD'} format={'YYYY-MM-DD HH:mm:ss'}  placeholder="请求时间" />
                        </Form.Item>
                        <Form.Item name="requestRangeTime">
                            <DatePicker.RangePicker valueFormat={'YYYY-MM-DD'} format={'YYYY-MM-DD HH:mm:ss'}  showTime/>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">筛选查询</Button>
                            <Button style={{marginLeft:8}} onClick={()=>this.initSummaryDataList()}>查询汇总</Button>
                            <Button type="link" onClick={this.handleReset}>重置筛选</Button>
                        </Form.Item>
                        {/*<Form.Item*/}
                        {/*    name="status"*/}
                        {/*>*/}
                        {/*    <Select*/}
                        {/*        style={{minWidth:'200px'}}*/}
                        {/*        allowClear*/}
                        {/*        showSearch*/}
                        {/*        placeholder="状态"*/}
                        {/*        filterOption={(input, option) =>*/}
                        {/*            (option?.name ?? '').toLowerCase().includes(input.toLowerCase())*/}
                        {/*        }*/}
                        {/*        options={[*/}
                        {/*            {label:'所有',value:''},*/}
                        {/*            // {label:'待下发',value:0},*/}
                        {/*            {label:'已下发',value:1},*/}
                        {/*            {label:'已评分',value:2},*/}
                        {/*            {label:'已汇算',value:3},*/}
                        {/*            {label:'已结束',value:4},*/}
                        {/*        ]}*/}
                        {/*    />*/}
                        {/*</Form.Item>*/}
                    </Form>
                    <Divider orientation="left">汇总</Divider>
                    <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12,flexWrap:'wrap'}}>
                        <Select
                            style={{width:160}}
                            value={this.state.summaryParam.dimension}
                            options={summaryDimensionOptions}
                            onChange={(value)=>{
                                this.setState({
                                    summaryParam:{...this.state.summaryParam,dimension:value}
                                },()=>this.initSummaryDataList())
                            }}
                        />
                        <Select
                            style={{width:160}}
                            value={this.state.summaryParam.timeUnit}
                            options={summaryTimeUnitOptions}
                            onChange={(value)=>{
                                this.setState({
                                    summaryParam:{...this.state.summaryParam,timeUnit:value}
                                },()=>this.initSummaryDataList())
                            }}
                        />
                        <InputNumber
                            style={{width:160}}
                            min={1}
                            max={1000}
                            value={this.state.summaryParam.limit}
                            placeholder="Top N"
                            onChange={(value)=>{
                                this.setState({
                                    summaryParam:{...this.state.summaryParam,limit:value}
                                })
                            }}
                            onPressEnter={()=>this.initSummaryDataList()}
                        />
                        <Button onClick={()=>this.initSummaryDataList()}>刷新汇总</Button>
                    </div>
                    <Table
                        bordered
                        size="small"
                        pagination={false}
                        rowKey={(record,index)=>`${record.time||''}-${record.dimensionValue||''}-${index}`}
                        dataSource={this.state.summaryDataSource}
                        columns={this.state.summaryColumns}
                        loading={this.state.summaryLoading}/>
                    <Divider orientation="left">明细</Divider>
                    <Table
                        bordered
                        size="small"
                        pagination={false}
                        dataSource={dataSource}
                        columns={columns}
                        scroll={{x:3000}}
                        loading={loading}/>
                    <div style={{display:'flex',justifyContent:'flex-end',margin:'20px 0'}}>
                        <Pagination size="small"
                                    hideOnSinglePage={true}
                                    current={this.state.formParam.currentPage}
                                    pageSize={this.state.formParam.pageSize}
                                    total={this.state.total}
                                    showSizeChanger
                                    onChange={(page, pageSize)=>{
                                        console.log(page, pageSize)
                                        let param = this.state.formParam
                                        param.pageSize = pageSize
                                        param.currentPage = page
                                        this.setState({
                                            formParam:{...param}
                                        })
                                        this.initTableDataList()
                                    }}
                        />

                    </div>
                </Card>
            </div>

        )
    }
}
